import { createContext } from 'react';

const QuestionnaireContext = createContext();
export default QuestionnaireContext;
